export const cateringUpcomingChecklist = [
  { label: 'Drop off/Serving', key: 'serviceStyle', boolean: false },
  { label: 'Individually Labeled', key: 'individualLabel', boolean: true },
  { label: 'Serving Utensils', key: 'servingUtensils', boolean: true },
  { label: 'Plates, Utensils, Napkins', key: 'utensilsPlatesNapkins', boolean: true },
  { label: 'Chaffing Frames', key: 'chaffingFrames', boolean: true },
  { label: 'Sternos', key: 'sternos', boolean: true },
];

export const cateringtDownloadConfig = {
  sectionLabel: 'Documents Downloads',
  leftButtonLabel: 'Packing Slip',
  leftDownloadUrl: '',
  rightButtonLabel: 'Purchase Order',
  rightDownloadUrl: '',
  leftIcon: 'IconReceiptDollar',
  rightIcon: 'IconPaperBag',
  rightSectionIcon: true,
};
